module.exports = __webpack_public_path__ + "static/media/how-it-works-2.ac9d5245.png";